import { Capacitor } from '@capacitor/core';

/** Сайт открыт внутри приложения для iPhone, а не в браузере. */
export const isApp = (): boolean => Capacitor.isNativePlatform();
